<template>
    <div>
    </div>
</template>
<script>

export default {
    data(){
        return{
            tabIndex:''

        }
    },
    created(){
        if(this.$route.query.tabIndex){
            this.$router.replace({
                path:'/',
                query:{
                    tabIndex:this.$route.query.tabIndex,
                    messageType:this.$route.query.messageType,
                    clickMessId:this.$route.query.clickMessId,
                }
            })
        }else{
            this.$route.replace({
                path:'/',
                query:{
                     messageType:this.$route.query.messageType,
                    clickMessId:this.$route.query.clickMessId,
                }
            })
        }

    }
}
</script>



// WEBPACK FOOTER //
// src/view/jumpTab/index.vue